import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import CardsListBackdrop from "components/Backdrops/CardsListBackdrop";
import PageTitleHeader from "components/Headers/PageTitleHeader.js";
import useFilterSync from "hooks/useFilterSync";
import { getSearchedInformationAction } from "redux/actions/informationDisseminationAction";
import { labels, titles } from "resources/resources";
import {
    INFORMATION_DISSEMINATION_TYPE_KEYVALUE,
    INFORMATION_TYPES,
    PAGINATION,
    RESOURCES_TYPES,
} from "utils/const";
import { removeAccents } from "utils/string_utils";
import InformationSearchCard from "views/admin/InformationSearch/Card/InformationSearchCard";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function InformationSearchInner(props) {
  const classes = useStylesGeneric();
  const intl = useIntl();

  const [uiSearchResultList, setUiSearchResultList] = useState([]);
  const [allSearchResultList, setAllSearchResultList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const { watch, setValue, reset, getValues } = useFormContext();
  const pageIndex = watch("pageIndex") ?? PAGINATION.FIRST_PAGE;
  const pageSize = watch("pageSize") ?? PAGINATION.PAGE_SIZE_DISSEMINATION;
  const searchText = watch("searchText") ?? "";

  const filterSync = useFilterSync({
    defaultValues: props.defaultFormValues,
    syncPagination: true,
    pagination: {
      pageIndexKey: "pageIndex",
      pageSizeKey: "pageSize",
      defaultPageSize: props.defaultFormValues?.pageSize ?? PAGINATION.PAGE_SIZE_DISSEMINATION,
    },
  });

  const resourcesDataList = useMemo(
    () => [
      //INEFOP Menu
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_Overview
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_Overview
        ),
        path: "/institution-overview",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_History
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_History
        ),
        path: "/institution-history",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_MissionVisionAndValues
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_MissionVisionAndValues
        ),
        path: "/institution-mission-vision-values",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_OrganicStatus
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_OrganicStatus
        ),
        path: "/institution-organic-status",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_OrganizationChart
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_OrganizationChart
        ),
        path: "/institution-organization-chart",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_DirectorBiography
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_DirectorBiography
        ),
        path: "/director-biography",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_InstitutionalInformation_InstituteChiefs
        ),
        title: intl.formatMessage(
          titles.Title_Menu_InstitutionalInformation_InstituteChiefs
        ),
        path: "/institute-holders",
      },

      //Information Menu
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_EmploymentServices_EmploymentCenters
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_EmploymentServices_EmploymentCenters
        ),
        path: "/information-employment-centers",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_EmploymentServices_Employment_Centers_Network
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_EmploymentServices_Employment_Centers_Network
        ),
        path: "/information-employment-centers-network",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_EmploymentServices_ForeignWorkersContractRegistration
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_EmploymentServices_ForeignWorkersContractRegistration
        ),
        path: "/information-foreign-workers-contract-registration",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_EntrepreneurshipServices
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_EntrepreneurshipServices_EntrepreneurshipCenters
        ),
        path: "/information-entrepreneurship-centers",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_EntrepreneurshipServices_EntrepreneurshipCentersNetwork
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_EntrepreneurshipServices_EntrepreneurshipCentersNetwork
        ),
        path: "/information-entrepreneurship-centers-network",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_ProfessionalTraining_ProfessionalWallet
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_ProfessionalTraining_ProfessionalWallet
        ),
        path: "/information-professional-wallet",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_ProfessionalTraining_FormationOffer
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_ProfessionalTraining_FormationOffer
        ),
        path: "/information-formation-offer",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_ProfessionalTraining_TrainingCentersLicensing
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_ProfessionalTraining_TrainingCentersLicensing
        ),
        path: "/information-training-centers-licensing",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_CompanyServices_RatifyAgreement
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_CompanyServices_RatifyAgreement
        ),
        path: "/ratify-agreement",
      },
      {
        prefix: intl.formatMessage(
          labels.Label_Search_Menu_Information_CompanyServices_NominalWorkersRegister
        ),
        title: intl.formatMessage(
          titles.Title_Menu_Information_CompanyServices_NominalWorkersRegister
        ),
        path: "/nominal-workers-register",
      },

      //Statistics
      {
        prefix: intl.formatMessage(labels.Label_Search_Menu_Statistics),
        title: intl.formatMessage(titles.Title_Menu_Statistics),
        path: "/statistics",
      },
    ],
    [intl]
  );

  useEffect(() => {
    const nextSearchText = props.match?.params?.searchText ?? "";
    const currentSearchText = getValues("searchText") ?? "";

    if (currentSearchText === nextSearchText) return;

    reset({
      searchText: nextSearchText,
      pageIndex: PAGINATION.FIRST_PAGE,
      pageSize,
    });

    // Manter paginação sincronizada na URL (volta para 1 quando muda o termo)
    filterSync.updatePagination(PAGINATION.FIRST_PAGE, pageSize);
  }, [props.match?.params?.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mantém paginação sincronizada na URL
  useEffect(() => {
    filterSync.updatePagination(pageIndex, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize]);

  useEffect(() => {
    if (!searchText) return;

    getAllUiInformation(searchText);

    const isLoggedIn =
      props.authState?.loggedIn !== undefined && props.authState?.loggedIn;

    const filter = {
      searchText,
      isPublic: isLoggedIn ? null : true,
      published: true,
      pageIndex,
      pageSize,
    };

    props.getSearchedInformation(filter);
  }, [searchText, pageIndex, pageSize]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const nrRecordsAPI =
      props.informationDisseminationState?.searchedInformation_total_records ??
      0;
    const nrRecordsUI = Object.keys(uiSearchResultList).length;

    const searchFromAPI =
      props.informationDisseminationState?.searchedInformation_result?.data?.map(
        (prop) => {
        return {
          title: prop.title,
          description: prop.description.replace(/(<([^>]+)>)/gi, ""),
          informationDisseminationTypeDescription:
            prop.informationDisseminationTypeDescription ===
            INFORMATION_TYPES.INFORMATION
              ? INFORMATION_TYPES.NEWS
              : prop.informationDisseminationTypeDescription,
          informationDisseminationTypeKeyValue:
            prop.informationDisseminationTypeKeyValue,
          searchResultPath:
            (props.authState?.loggedIn ? "/admin" : "/auth") +
            "/informationDissemination-details/" +
            prop.alternateKey,
          publishedOn: prop.publishedOn,
          photo: prop.photo,
        };
      }
      );

    const searchFromUI = Object.keys(uiSearchResultList)
      .map((key) => {
        return {
          title: resourcesDataList?.find((label) => label.prefix === key).title,
          description: uiSearchResultList[key].defaultMessage,
          informationDisseminationTypeDescription:
            INFORMATION_TYPES.INFORMATION,
          informationDisseminationTypeKeyValue:
            INFORMATION_DISSEMINATION_TYPE_KEYVALUE.INFORMATION,
          searchResultPath:
            (props.authState?.loggedIn ? "/admin" : "/auth") +
            resourcesDataList?.find((label) => label.prefix === key).path,
          publishedOn: null,
          photo: null,
        };
      })
      .slice(
        Math.max(
          0,
          (pageIndex - 1) * pageSize - nrRecordsAPI
        ),
        pageSize * pageIndex - 1
      );

    setAllSearchResultList(
      searchFromAPI
        ?.concat(searchFromUI)
        ?.slice(0, pageSize)
    );

    setTotalPages(
      Math.ceil((nrRecordsAPI + nrRecordsUI) / pageSize)
    );
  }, [
    props.informationDisseminationState?.searchedInformation_result?.data,
    props.informationDisseminationState?.searchedInformation_total_records,
    uiSearchResultList,
    pageIndex,
    pageSize,
    resourcesDataList,
    props.authState?.loggedIn,
  ]);

  const handleChangePage = (event, value) => {
    setValue("pageIndex", value);
  };

  const getAllUiInformation = (searchText) => {
    let searchTextArray = searchText
      .trim()
      .split(" ")
      .filter((str) => str !== "");

    const prefix_values = resourcesDataList.map((label) => {
      return label.prefix;
    });

    const filteredLabelsList = Object.keys(labels)
      .filter(
        (key) =>
          searchTextArray.some((word) =>
            removeAccents(labels[key].defaultMessage.toLowerCase()).includes(
              removeAccents(word.toLowerCase())
            )
          ) &&
          prefix_values.some((prefix) => key.includes(prefix)) &&
          !key.includes("Label_Search_Menu_")
      )
      .reduce((obj, key) => {
        return Object.assign(obj, {
          [key]: {
            ...labels[key],
            type: RESOURCES_TYPES.LABEL,
          },
        });
      }, {});

    const filteredTitlesList = Object.keys(titles)
      .filter(
        (key) =>
          searchTextArray.some((word) =>
            removeAccents(titles[key].defaultMessage.toLowerCase()).includes(
              removeAccents(word.toLowerCase())
            )
          ) &&
          prefix_values.some((prefix) => key.includes(prefix)) &&
          !key.includes("Label_Search_Menu_")
      )
      .reduce((obj, key) => {
        return Object.assign(obj, {
          [key]: {
            ...titles[key],
            type: RESOURCES_TYPES.TITLE,
          },
        });
      }, {});

    const filteredLabelsAndTitlesList = {
      ...filteredLabelsList,
      ...filteredTitlesList,
    };

    const oneResultPerPagefilteredLabelsAndTitlesList = Object.keys(
      filteredLabelsAndTitlesList
    ).reduce((obj, key) => {
      const prefix = prefix_values.find((prefix) => key.includes(prefix));
      if (prefix && !(prefix in obj)) {
        obj[prefix] = filteredLabelsAndTitlesList[key];
      }
      return obj;
    }, {});

    setUiSearchResultList(oneResultPerPagefilteredLabelsAndTitlesList);
  };

  return (
    <Grid container classes={{ root: classes.containerRoot }}>
      <PageTitleHeader title={intl.formatMessage(titles.Title_SearchResults)} />

      <Grid item xs={12} md={12}>
        {allSearchResultList !== undefined && allSearchResultList?.length > 0 ? (
          <Grid container style={{ position: "relative" }}>
            {allSearchResultList?.map((info, key) => (
              <Grid key={key} item xs={12} md={6} lg={4} xl={3}>
                <InformationSearchCard
                  informationDisseminationTypeDescription={info.informationDisseminationTypeDescription}
                  informationDisseminationTypeKeyValue={info.informationDisseminationTypeKeyValue}
                  title={info.title}
                  description={info.description}
                  publishedOn={info.publishedOn}
                  photo={info.photo}
                  searchResultPath={info.searchResultPath}
                  itemKey={key}
                />
              </Grid>
            ))}
            <CardsListBackdrop open={props.informationDisseminationState?.searchedInformation_loading} />
          </Grid>
        ) : (
          <div className={classes.noResultsInfo}>{intl.formatMessage(labels.Label_No_Results_Found)}</div>
        )}
        <Pagination
          className={classes.alignPagination}
          count={totalPages}
          page={pageIndex}
          onChange={handleChangePage}
          color="primary"
        ></Pagination>
      </Grid>
    </Grid>
  );
}

function InformationSearch(props) {
  const defaultFormValues = useMemo(
    () => ({
      searchText: props.match?.params?.searchText ?? "",
      pageIndex: PAGINATION.FIRST_PAGE,
      pageSize: PAGINATION.PAGE_SIZE_DISSEMINATION,
    }),
    [props.match?.params?.searchText]
  );

  const formMethods = useForm({
    defaultValues: defaultFormValues,
  });

  return (
    <FormProvider {...formMethods}>
      <InformationSearchInner {...props} defaultFormValues={defaultFormValues} />
    </FormProvider>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getSearchedInformation: (data) => dispatch(getSearchedInformationAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InformationSearch);
